import React, { useEffect, useRef } from "react";
import cssClasses from "./AboutUs.module.css";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
export default function AboutUs() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.activeMenu("help"));
  }, []);
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.title}>About Us</div>
      <div className={cssClasses.content}>
        <div className={cssClasses.title}>Overview</div>
        What essentially guides an organisation during its journey, scaling new
        heights - one mission after another, towards their vision, with
        consistency, is its philosophy. At Vilas Javdekar Developers, the very
        essence of our philosophy consists of a reverberant belief – We Love
        What We Do! When you love what you do, it reflects in the work you do,
        the love and respect you earn, and the appreciation bestowed upon you.
        This philosophy is the foundation of every single activity undertaken by
        Vilas Javdekar Developers. This is what sets team VJ apart from the
        rest. It is what empowers us to be a good organisation, and inspires us
        to keep challenging our peak potential.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Leaders</div>
        <div className={cssClasses.founders}>Vilas Javdekar Founder & Chairman</div>
        Trust and design are our company's core values. Everything we imagine
        and create is infused with these two indelible elements of our success
        story. Our company and projects have won several prestigious awards over
        the years. This has been possible due to the efforts and passion of the
        entire team. Our vision for the future is building more goodwill and
        creating even more happy communities, with the strong foundation of our
        corporate philosophy and core values.
        <br></br>
        <br></br>
        <div className={cssClasses.founders}>Aditya Javdekar CEO</div>
        At Vilas Javdekar Developers, we firmly believe that planning is the
        most important stage of any project. The whole team takes effort to plan
        everything from design to materials and even the possession date. With a
        precise and solid plan at the helm, we have maintained a track record of
        always delivering projects on time (and sometimes even before the
        promised time). Our passion for work shows in the fact that we give our
        customers a 'Possession Guarantee', and we stick by our word.
        <br></br>
        <br></br>
        <div className={cssClasses.founders}>Sarvesh Javdekar Director, Operations</div>
        The entire technical team at Vilas Javdekar Developers always tries to
        think of innovative and futuristic methods. Be it the architecture, the
        interior space utilisation or even the materials to be used. Due to our
        constant pursuit of perfection, we have won many awards for our projects
        and the company. But our biggest achievement is seeing the smiles of our
        customers, when we handover possession of their home on time.
        <br></br>
        <br></br>
        <div className={cssClasses.title}>Core Values</div>
        Our solid foundation of trust has been built over the years, through
        testing and opportune times alike. It is due to this trust that Vilas
        Javdekar Developers has earned the respect and goodwill which we embody
        today. All this goodwill stems from our passion for what we do. And when
        we speak of passion, we mean every word that we promise. Perhaps that is
        why we have a consistent track record of on-time delivery and a growing
        family of loyal customers. Another aspect that sets us apart is our
        'Possession Guarantee' for each of our projects. We strive hard to
        ensure that once we commit a possession date to a customer, it is met
        under any circumstance.
        <br></br> <br></br>
        Innovative design has always been at the core of all our endeavours.
        From our office furniture to some of our most prized structures, design
        is an integral part of our DNA. But innovative designs mean researching
        for new materials, delivery techniques and maintaining our track record
        of possession. Through our undying love for what we do, we have
        maintained the highest design standards while staying true to our
        promises. And this has led us to winning several awards across several
        projects and categories. As we continue our journey towards creating
        more iconic structures, we'll always stay true to the two values that
        have brought us success and goodwill – trust and design.
        <br></br> <br></br>
        <div className={cssClasses.title}>Signature Services</div>
        <div>Third-Party Audit of Homes at the Time of Possesion</div>
        Who decides a home is ready to be occupied by its proud residents? Well,
        at VJ, we believe in ensuring complete transparency in every aspect of
        building and delivering homes. Home Inspect is a unique offering by VJ,
        where homes are inspected by a third-party, once the homes are ready for
        handover. This third-party is CQRA, a highly trusted organisation in
        this field, with high-level of expertise. A detailed audit report is
        prepared for every unit in a project that is ready for possession, by
        CQRA, for the convenience of the home owners.
        <br></br>
        <br></br>
        CORPORATE OFFICE
        <br></br>
        306, Siddharth Towers, Sangam Press Road, Kothrud, Pune 411 038
        <br></br>
        Contact No.: +91 20 6764 8000 / 01 / 02
        <br></br>
        Email: enquiry@javdekars.com
        <br></br>
        <br></br>
        BRANCH OFFICE
        <br></br>
        Centro Mall, 5th Floor, Next to Palash Plus Apartments, Opposite Euro School, Wakad, Pune 411057
        <br></br>
        Contact No.: 020 6764 8080
        <br></br>
        Email: enquiry@javdekars.com
      </div>
    </div>
  );
}
